// Copyright: IQGeo Limited 2010-2022
import myw from 'myWorld/base/core';
import './formComponent';

/**
 * @class  Textarea
 * @param  {string} options.value input value
 * @param  {function} options.onChange callback fired onKeyUp and Blur
 *
 * @example
 *     new myw.Textarea({value: "Hello World", onChange: function() {} })
 *
 * @extends {FormComponent}
 */
myw.Textarea = myw.FormComponent.extend({
    tagName: 'textarea',
    className: 'text ui-input',
    initialize(options) {
        myw.FormComponent.prototype.initialize.call(this, options);
        this.initUi();
        return this;
    },

    initUi() {
        if (this.options.value) this.$el.text(this.options.value);
    }
});

myw.View.prototype.componentMapping['textarea'] = myw.Textarea;
export default myw.Textarea;
